<template>
  <b-container
    v-if="!isTestView"
    class="bv-example-row"
    fluid
  >
    <b-row align-h="between">
      <b-col cols="auto">
        <h3>ประเภทการตรวจ</h3>
      </b-col>
      <b-col cols="auto">
        <b-button
          variant="success"
          @click="openFieldModal"
        >
          เพิ่มประเภทตรวจ
        </b-button>
      </b-col>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="items"
        primary-key="sequence"
        sort-by="sequence"
      >
        <template
          slot="sequence"
          slot-scope="data"
        >
          <div class="col-left">
            <b-row>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'caret-up']"
                  :class="{'icon': true, 'disable': checkMinMax(data.item.sequence, items, 'sequence', 'min')}"
                  @click="changePositionHandler(data.item.id, 'up')"
                />
              </b-col>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'caret-down']"
                  :class="{'icon': true, 'disable': checkMinMax(data.item.sequence, items, 'sequence', 'max')}"
                  @click="changePositionHandler(data.item.id, 'down')"
                />
              </b-col>
              <b-col cols="auto">
                {{ data.item.sequence }}
              </b-col>
            </b-row>
          </div>
        </template>
        <template
          slot="name"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.name }}
          </div>
        </template>
        <template
          slot="abbreviation"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.abbreviation }}
          </div>
        </template>
        <template
          slot="created_at"
          slot-scope="data"
        >
          <div class="col-center">
            {{ data.item.created_at }}
          </div>
        </template>
        <template
          slot="action"
          slot-scope="data"
        >
          <b-container fluid>
            <b-row align-h="center">
              <b-col cols="auto">
                <!--                                    <fa-icon-->
                <!--                                        :icon="['fas', 'arrow-right']"-->
                <!--                                        class="icon"-->
                <!--                                        @click="openTestHandler(data.item.id)"-->

                <!--                                    />-->
                <b-button
                  class="button btn-dark"
                  @click="openTestHandler(data.item.id)"
                >
                  ดูรายละเอียด
                </b-button>
                <!--                                    <b-button variant="warning" @click="openFieldModal(data.item.id)">-->
                <!--                                        แก้ไข-->
                <!--                                    </b-button>-->
              </b-col>
              <b-col cols="auto">
                <!--                                    <fa-icon-->
                <!--                                        :icon="['fas', 'edit']"-->
                <!--                                        class="icon warning"-->
                <!--                                        @click="openFieldModal(data.item.id)"-->

                <!--                                    />-->
                <b-button
                  class="button btn-warning"
                  @click="openFieldModal(data.item.id)"
                >
                  แก้ไข
                </b-button>
                <!--                                    <b-button variant="warning" @click="openFieldModal(data.item.id)">-->
                <!--                                        แก้ไข-->
                <!--                                    </b-button>-->
              </b-col>
              <b-col cols="auto">
                <!--                                    <fa-icon-->
                <!--                                        :icon="['fas', 'trash']"-->
                <!--                                        class="icon danger"-->
                <!--                                        @click="openDeleteModal(data.item.id)"-->

                <!--                                    />-->
                <b-button
                  class="button btn-danger"
                  @click="openDeleteModal(data.item.id)"
                >
                  ลบ
                </b-button>
                <!--                                    <b-button variant="danger" @click="openDeleteModal(data.item.id)">-->
                <!--                                        ลบ-->
                <!--                                    </b-button>-->
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
    </b-row>
    <b-modal
      ref="inputModal"
      :title="modalTitle"
      @ok="submit"
      @shown="clearInputField"
    >
      <input-modal :fields.sync="inputFields" />
    </b-modal>
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delTestType"
    >
      <confirm-modal />
    </b-modal>
  </b-container>
  <test-view
    v-else
    :test-type-name="testTypeSelectedName"
    :test-type-id="testTypeSelected"
    :tests.sync="tests"
    :back-handler="backTestHandler"
  />
</template>

<script>
  import {mapActions} from "vuex"
  import InputModal from "../../components/Settings/InputModal"
  import ConfirmModal from "../../components/Settings/ConfirmModal"
  import draggable from 'vuedraggable'
  import _ from 'lodash'
  import TestView from "./Test"
  import Swal from 'sweetalert2'

  export default {
    name: "TestType",
    components: {
      InputModal,
      ConfirmModal,
        TestView,
    },
    data() {
      return {
        fields: [
          {
            key: 'sequence',
            label: 'NO',
            isInputField: false,
          },
          {
            key: 'name',
            label: 'NAME',
            isInputField: true,
            isSpecialField: false,
            fieldType: 'text'
          },
          {
            key: 'abbreviation',
            label: 'ABBREVIATION',
            isInputField: true,
            isSpecialField: false,
            fieldType: 'text'
          },

          // {
          //   key: 'created_at',
          //   label: 'DATE CREATED',
          //   isInputField: false,
          // },
          {
            key: 'action',
            label: 'ACTIONS',
            isInputField: false,
          }
        ],
        inputFields: [
          {
            key: 'name',
            label: 'Name',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
          {
            key: 'abbreviation',
            label: 'Abbreviation',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
        ],
        items: [],
        itemSelected: null,
        modalTitle: "",
        deleteTestTypeIdSelected: null,
          isTestView: false,
          testTypeSelected: null,
          tests: [],
          testTypeSelectedName: '',
      }
    },
    methods: {
      ...mapActions({
        getTestTypes: "Settings/getTestTypeList",
        createTestType: "Settings/createTestType",
        updateTestType: "Settings/updateTestType",
        deleteTestType: "Settings/deleteTestType",
          updateSequenceTestType: "Settings/updateSequenceTestType",
          getTestByTestTypeId: "Settings/getTestByTestTypeId"


      }),
      async openFieldModal (testTypeId = null) {
        this.itemSelected= this.items.find((item) => {
          return item.id === testTypeId;
        }) || null;

        this.$refs['inputModal'].show();
      },
      openDeleteModal (testTypeId) {
        this.deleteTestTypeIdSelected = testTypeId
        this.$refs['confirmDelete'].show();
      },
      async submit() {
        let payload = {}
        let malformedCheck = false
        this.inputFields.forEach(el => {
          if (el.value === null || el.value === '' ||  el.value === undefined) {
            if (!el.required) {
              payload[el.key] = el.default
            } else {
              malformedCheck = true
              this.$swal.fire('กรอกข้อมูลไม่ครบ')
            }
          } else {
            payload[el.key] = el.value;
          }
        })

        if (malformedCheck) {
          return ;
        }

        if (this.itemSelected) {
          var res = await this.updateTestType({
            payload,
            id: this.itemSelected.id
          });
        } else {
          var res = await this.createTestType(payload);
        }

        Swal.fire('เสร็จสิ้น', 'บันทึกสำเร็จ', 'success')
        // alert("บันทึกเสร็จสิ้น")
        this.items = await this.getTestTypes()
        this.$refs['inputModal'].hide()
        this.itemSelected = null

      },
      clearInputField() {
        if (this.itemSelected) {
          this.inputFields.forEach(el=> {
            el.value = this.itemSelected[el.key]
          })
        } else {
          this.inputFields.forEach(el=> {
            el.value = ''
          })
        }
        this.modalTitle = this.itemSelected ? 'แก้ไขข้อมูล' : 'เพิ่มข้อมูล';
      },
      async delTestType () {
        let res = await this.deleteTestType(this.deleteTestTypeIdSelected)
        this.deleteTestTypeIdSelected = null
        this.items = await this.getTestTypes()
        this.$refs['confirmDelete'].hide();
      },
        async changePositionHandler(id, type) {
            this.$store.state.isLoading = true;
            let prepareSequence = []
            try {
                prepareSequence = this.items.map(item => ({id: item.id, sequence: item.sequence}));
                let itemChange = prepareSequence.find(item => item.id === id)
                let newIndex = type === 'up' ? itemChange.sequence === 1 ? 1 : itemChange.sequence - 1 : itemChange.sequence === _.maxBy(prepareSequence, 'sequence') ? _.maxBy(prepareSequence, 'sequence') : itemChange.sequence + 1;
                prepareSequence.forEach(item => {
                    if (item.sequence === newIndex) {
                        item.sequence = type === 'up' ? item.sequence + 1 : item.sequence - 1
                    }
                    if (item.id === id ) {
                        item.sequence = newIndex
                    }
                })
            } catch (e) {
                this.$store.state.isLoading = false;
            }

            try {
                await this.updateSequenceTestType(prepareSequence)
            } catch (e) {

            }

            this.$nextTick(async () => {
                try {
                    this.items = await this.getTestTypes()
                } catch (e) {
                    this.$store.state.isLoading = false;
                }
                this.$store.state.isLoading = false;
            })

        },
        checkMinMax(item, array, needle, type) {
            if (type === 'min') {
                return item === _.minBy(array, needle)[needle]
            } else if (type === 'max') {
                return item === _.maxBy(array, needle)[needle]
            }
        },
        async openTestHandler(id) {
            this.tests = await this.getTestByTestTypeId(id)
          this.isTestView = true
            this.testTypeSelected = id
            this.testTypeSelectedName = this.items.find(item => item.id === id).name

        },
        backTestHandler() {
          this.isTestView = false
            this.testTypeSelected = null
            this.tests = []
            this.testTypeSelectedName = ''
        }
    },
    async mounted() {
      this.items = await this.getTestTypes()
    }
  }
</script>

<style lang="scss" scoped>
    .icon {
        cursor: pointer;
        &.warning {
            color: #ffc107 ;
        }
        &.danger {
            color: #dc3545;
        }
        &.disable {
            opacity: 0.4;
            cursor: default;
        }
    }
</style>
